export default "__VITE_ASSET__ChjCA8XP__"